import styles from "./Background.module.scss";
import {ARTIST, Artist} from "../utils/artist.utils";
import backgroundRiize from "../assets/images/riize/background_riize.png";
import backgroundAespa from "../assets/images/aespa/background_aespa.png";

type BackgroundProps = {
  artist: Artist;
};

const Background = ({artist}: BackgroundProps) => {
  const backgroundImage =
    artist === ARTIST.aespa ? backgroundAespa : backgroundRiize;

  return (
    <div className={styles.background}>
      <img src={backgroundImage} className={styles.image} alt="" />
    </div>
  );
};

export default Background;
